import { render, staticRenderFns } from "./500.vue?vue&type=template&id=940de63e&scoped=true"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940de63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('940de63e')) {
      api.createRecord('940de63e', component.options)
    } else {
      api.reload('940de63e', component.options)
    }
    module.hot.accept("./500.vue?vue&type=template&id=940de63e&scoped=true", function () {
      api.rerender('940de63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/exception/500.vue"
export default component.exports